import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const FinanceIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon code="payments" {...props}/>
    );
}
